// Evaluate product flags
// Keep original filter flag for price logic elsewhere
const __filterUVRaw = (document.querySelector('.product__title[data-filter_uv]')?.getAttribute('data-filter_uv') || '').trim().toLowerCase();
// New rule: show plan buttons only when variant-selects exists; otherwise hide
const __hasVariantSelects = !!document.querySelector('variant-selects');
const __hideSellingPlans = __hasVariantSelects ? false : true;

const rechargeStyles = `
rc-selling-plans {
    display: ${__hideSellingPlans ? 'none' : 'block'}!important;
}

.rc-price {
    font-size: 24px;
    line-height: 29px;
}

.rc-price.strike-through {
    font-weight: 400;
    font-size: 16px;
    line-height: 29px;
}
.rc-plans-dropdown.rc-widget-redesign {
    display: none !important;
}
.rc-widget-redesign .rc-purchase-option__selector,
.rc-widget-redesign .rc-selection__onetime.rc-purchase-option[rc-selected] .rc-purchase-option__selector {
    color: #161617 !important;
    font-size: 18px !important;
}
.rc-widget-redesign ul li p,
.rc-widget-redesign ul li {
    color: #161617 !important;
    font-size: 14px !important;
}
.rc-widget-redesign.rc-benefits__list {
    padding-bottom: 5px !important;
}
.rc-widget-redesign ul li::before,
.rc-widget-redesign .rc-benefits__list ul li::before {
    background-color: #0071E3 !important;
}
.rc-widget-redesign .rc-purchase-option[rc-selected] {
    border: 2px solid #0071E3 !important;
}
.rc-widget-redesign .rc-purchase-option__badge {
    font-size: 14px !important;
    padding: 6px 10px !important;
    top: 1.2em !important;
    right: 10rem !important;
}
.rc-widget-redesign .rc-price.strike-through, 
.rc-widget-redesign .rc-price,
.rc-widget-redesign .rc-selection__onetime.rc-purchase-option[rc-selected] .rc-price {
    color: #161617 !important;
    font-size: 18px !important;
}
.rc-widget-redesign .rc-price.strike-through {
    font-size: 14px !important;
}
.rc-widget-redesign .rc-plans__label {
    display: block !important;
    color: #161617 !important;
    margin-bottom: 12px !important;
}
.rc-widget-redesign .rc-plans-button[data-checked]  {
    outline: 0 !important;
}
.rc-widget-redesign label {
    width: auto !important;
    flex-grow: 0 !important;
    max-height: none !important;
}
.rc-widget-redesign .rc-plans-button  {
    outline: 0 !important;
    border: 2px solid #0071E3 !important;
    width: auto !important;
    flex-grow: 0 !important;
    padding: 10px !important;
}
.rc-widget-redesign .rc-plans-button:not([data-checked]) {
    background-color: #FFFFFF !important;
    color: #161617 !important;
}
.rc-widget-redesign .rc-plans-button[data-checked] {
    background-color: #0071E3 !important;
    color: #FFFFFF !important;
}
.rc-widget-redesign .rc-plans-button .rc-plans-button__discount {
    font-size: 12px !important;
}
.rc-widget-redesign .rc-plans-button .rc-plans-button__interval {
    font-size: 15px !important;
}
.rc-widget-redesign .rc-purchase-option {
    border: 1px solid #86868B4D !important;
    box-shadow: none !important;
}

.rc-purchase-option__subscription {
    padding-bottom: 20px!important;
}

.rc-purchase-option__subscription[rc-not-selected] .rc-price,
.rc-purchase-option__subscription[rc-not-selected] .rc-purchase-option__selector {
    color: #161617!important;
}

.rc-purchase-option__sub-container {
    padding: 0px 20px 0px 20px!important;
}

.rc-purchase-option__badge {
    top: 2em !important;
    right: 10.5em !important;
    font-size: 10px !important;
    line-height: 10px !important;
    padding: 2px 10px !important;
    font-weight: 700 !important;
}

.rc-purchase-option__subscription[rc-not-selected] {
    background-color: #FFFFFF!important;
    border: 1px solid #86868B4D;
    box-shadow: 0px 4px 4px 0px #0000001A;
}

.rc-purchase-option__subscription[rc-not-selected] .rc-purchase-option__badge {
    background-color: #FFFFFF!important;
    border: 1px solid #86868B4D;
    box-shadow: 0px 4px 4px 0px #0000001A;
    color: #161617!important;
}

.rc-purchase-option__label {
    padding-bottom: 0px !important;
}

.rc-purchase-option__selector {
    font-size: 18px !important;
    line-height: 24px !important;
}

.rc-purchase-option__checked-indicator {
    pointer-events: none;
}

.rc-benefits__list {
    padding-left: 3.5em;
    padding-bottom: 1.5em;
}

.rc-drawbacks {
    padding-left: 3.5em;
}

.rc-benefits__list ul li,
.rc-drawbacks ul li {
    padding-left: 22px !important;
}

.rc-benefits__list ul li p,
.rc-drawbacks ul li p {
    font-size: 14px;
    line-height: 14px;
    font-weight: 300;
}

.compact p {
    margin: 1em 0;
}

.rc-benefits__list ul li::before {
    content: '';
    height: 1em;
    width: 1em;
    position: absolute;
    top: 0;
    left: 0;
    mask-image: url('data:image/svg+xml;utf8,<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_613_4985)"><path d="M9.85356 1.47452C9.65831 1.27925 9.34175 1.27925 9.14645 1.47452L3.15614 7.46489L0.853564 5.16231C0.658311 4.96704 0.341748 4.96706 0.146455 5.16231C-0.0488184 5.35757 -0.0488184 5.67413 0.146455 5.8694L2.80259 8.5255C2.99778 8.72075 3.31458 8.72061 3.5097 8.5255L9.85356 2.18163C10.0488 1.98637 10.0488 1.66979 9.85356 1.47452Z" fill="white"/></g><defs><clipPath id="clip0_613_4985"><rect width="10" height="10" fill="white"/></clipPath></defs></svg>');
    mask-size: 100%;
    background-color: #fff;
    mask-position: center center;
}

.compact.rc-drawbacks ul li::before {
    content: '';
    height: 1em;
    width: 1em;
    position: absolute;
    top: 0;
    left: 0;
    mask-image: url('data:image/svg+xml;utf8,<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_613_4985)"><path d="M9.85356 1.47452C9.65831 1.27925 9.34175 1.27925 9.14645 1.47452L3.15614 7.46489L0.853564 5.16231C0.658311 4.96704 0.341748 4.96706 0.146455 5.16231C-0.0488184 5.35757 -0.0488184 5.67413 0.146455 5.8694L2.80259 8.5255C2.99778 8.72075 3.31458 8.72061 3.5097 8.5255L9.85356 2.18163C10.0488 1.98637 10.0488 1.66979 9.85356 1.47452Z" fill="%23161617"/></g><defs><clipPath id="clip0_613_4985"><rect width="10" height="10" fill="%23161617 "/></clipPath></defs></svg>');
    mask-size: 100%;
    background-color: #FFFFFF;
    mask-position: center center;
}

.rc-plans-button-group {
    margin-left: 3.5em!important;
    margin-right: 6.5em!important;
}

.rc-plans-button-group label {
    max-height: 48px;
}

.rc-plans-button {
    padding: 12px 24px;
}

.rc-plans-button:not([data-checked]) {
    color: #FFFFFF!important;
    background-color: #0071E3;
    border: 1px solid #FFFFFF;
    font-weight: 600;
    font-size: 16px;
    line-height: 1;
    letter-spacing: 0;
}

.rc-plans-button:not([data-checked]):hover {
    background-color: #0071E3;
}

.rc-plans-button[data-checked] {
    color: #161617!important;
    background-color: #FFFFFF!important;
    font-weight: 600;
    font-size: 16px;
    outline: 2px solid #FFFFFF;
    outline-offset: 3px;
}

.rc-plans__label {
    display: contents !important;
}

.rc-selection__onetime {
    border: 1px solid #86868B4D !important;
    box-shadow: 0px 4px 4px 0px #0000001A;
    padding-bottom: 15px!important;
}

.rc-selection__onetime .rc-purchase-option__selector,
.rc-selection__onetime .rc-price {
    color: #161617 !important;
}

.rc-selection__onetime.rc-purchase-option[rc-selected] .rc-purchase-option__selector,
.rc-selection__onetime.rc-purchase-option[rc-selected] .rc-price {
    color: #ffffff!important;
}

.rc-plans-button__discount {
    font-size: 0.88em;
    line-height: 1.25em;
    font-weight: 400;
}

@media screen and (max-width: 1450px) {
    .rc-widget-redesign .rc-purchase-option__badge,
    .rc-purchase-option__badge {
        position: static !important;
        top: auto !important;
        right: auto !important;
        display: inline-block !important;
        margin: 0 !important;
        align-self: flex-end !important;
    }

    .rc-purchase-option__prices {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-end !important;
    }

    .rc-purchase-option__subscription .rc-purchase-option__prices,
    .rc-purchase-option__subscription .rc-purchase-option__sub-container {
        margin-top: .2rem;
    }
}

@media screen and (max-width: 749px) {
    .rc-widget-redesign.rc-plans-button-group {
        flex-wrap: nowrap;  
        flex-direction: row;
    }
    .rc-widget-redesign.rc-plans-button-group label {
        display: block !important;
    }
    .rc-purchase-option__label {
        padding: 12px 14px 8px 8px!important;
    }
    .rc-price {
        font-size: 18px;
    }
    .rc-benefits__list {
        padding-left: 0;
    }
    .rc-benefits__list ul li p, .rc-drawbacks ul li p {
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
    }
    .rc-plans-button-group {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    .rc-plans-button-group label {
        width: 100%!important;
    }
}

`;

// Helper function: tries to insert styles if they don't exist yet
const applyStyles = () => {
    const widget = document.querySelector('recharge-subscription-widget');
    const subSelectors = [
        'recharge-subscription-widget',
        'rc-radio-icon',
        'rc-benefits',
        'rc-onetime-drawbacks',
        'rc-selling-plans'
    ];

    let needsRetry = false;

    // Iterate over each selector and inject styles into ALL matching hosts
    for (const sel of subSelectors) {
        const hosts = sel === 'recharge-subscription-widget'
            ? (widget ? [widget] : [])
            : [...(widget?.shadowRoot?.querySelectorAll(sel) || [])];

        if (hosts.length === 0) {
            // Element may not be rendered yet; mark for retry
            needsRetry = true;
            continue;
        }

        hosts.forEach(host => {
            if (!host || !host.shadowRoot) {
            needsRetry = true;
            return;
            }

            if (!host.shadowRoot.querySelector('style[data-custom="true"]')) {
            const style = document.createElement('style');
            style.dataset.custom = 'true';
            style.textContent = rechargeStyles;
            host.shadowRoot.appendChild(style);
            }
        });
    }

    // If some elements were missing, try again shortly
    // Avoid a tight retry loop that can burn CPU on slow renders.
    if (needsRetry) {
        applyStyles.__retries = (applyStyles.__retries || 0) + 1;
        if (applyStyles.__retries <= 40) { // ~2s worst-case @ 50ms
            if (!applyStyles.__timer) {
                applyStyles.__timer = setTimeout(() => {
                    applyStyles.__timer = null;
                    applyStyles();
                }, 50);
            }
        } else {
            // Stop retrying aggressively; future scheduleApply() calls can retry when needed
            applyStyles.__retries = 40;
        }
    } else {
        applyStyles.__retries = 0;
    }

    const newSvgChecked = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="16" r="12" fill="white" stroke="#0071E3" stroke-width="2"/>
                                <circle cx="20" cy="16" r="6" fill="#0071E3"/>
                            </svg>

`;

    const newSvgUnchecked = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="16" r="12" fill="white" stroke="#C6C6C6" stroke-width="1"/>
                                <circle cx="20" cy="16" r="6" fill="white"/>
                            </svg>

`;

    widget?.shadowRoot?.querySelectorAll('rc-radio-icon').forEach(icon => {
        const sRoot = icon.shadowRoot;
        if (!sRoot) return;
        const isChecked = icon.hasAttribute('checked');
        const desired = isChecked ? newSvgChecked : newSvgUnchecked;
        const existing = sRoot.innerHTML.trim();
        if (existing !== desired.trim()) {
            sRoot.innerHTML = desired;
        }
    });
};

// Apply one-time discount (percentage) from data-one_time onto onetime price
function applyOnetimeDiscount() {
    const titleEl = document.querySelector('.product__title[data-v12-id]');
    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    if (!titleEl || !root) return;

    const priceEl = root.querySelector('.rc-selection__onetime .rc-price');
    if (!priceEl || priceEl.hasAttribute('data-ot-applied')) return;

    const toCents = (txt) => Math.round(parseFloat((txt || '').replace(/[^0-9.]/g, '')) * 100) || 0;
    const formatUSD = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);

    // Pick per-variant discount amount (in cents) from data attributes
    const currentVar = (function() {
        const idFromUrl = getVariantIdFromUrl();
        if (idFromUrl) return idFromUrl;
        const input = document.querySelector('product-info [id^="product-form-"] input[name="id"]');
        return input ? input.value : null;
    })();

    let subtractCents = 0;
    const v6Id = titleEl.getAttribute('data-v6-id');
    const v12Id = titleEl.getAttribute('data-v12-id');
    if (currentVar && v6Id && String(currentVar) === String(v6Id)) {
        const raw = (titleEl.getAttribute('data-v6-one_time') || '').trim();
        subtractCents = Math.round(parseFloat(raw) * 100) || 0;
    } else if (currentVar && v12Id && String(currentVar) === String(v12Id)) {
        const raw = (titleEl.getAttribute('data-v12-one_time') || '').trim();
        subtractCents = Math.round(parseFloat(raw) * 100) || 0;
    }

    const original = toCents(priceEl.textContent);

    // If variant-based fixed discount is present and valid, use it; otherwise fallback to product-level percent
    if (subtractCents > 0) {
        const discounted = Math.max(0, original - subtractCents);
        if (discounted !== original) {
            priceEl.textContent = formatUSD(discounted);
            priceEl.setAttribute('data-ot-applied', '1');
        } else {
            priceEl.setAttribute('data-ot-applied', '1');
        }
        return;
    }

    // Fallback: product-level percentage (legacy)
    const oneTimePctRaw = (document.querySelector('.product__title[data-one_time]')?.getAttribute('data-one_time') || '').trim();
    const pct = Number(oneTimePctRaw);
    if (isFinite(pct) && pct > 0) {
        const discounted = Math.max(0, Math.round(original * (1 - pct / 100)));
        if (discounted !== original) priceEl.textContent = formatUSD(discounted);
        priceEl.setAttribute('data-ot-applied', '1');
    }
}

// Helper to consistently get the widget element
function getRechargeWidget() {
    return document.querySelector('recharge-subscription-widget');
}

// (Removed dynamic shadowRoot injection; display is handled via rechargeStyles)

// Simple debounce so applyStyles is not called more often than once every 150ms
let debouncePending = false;
// Suppress one navigation when we simulate a click to let Recharge recompute prices
let __rc_suppressNavigateOnce = false;
function scheduleApply() {
    if (debouncePending) return;
    debouncePending = true;
    setTimeout(() => {
        debouncePending = false;
        // Guard: do nothing on pages without the Recharge widget
        if (!getRechargeWidget()) return;

        applyStyles();
        applyOnetimeDiscount();
        syncAddToCartPrice();
        attachAddToCartLabelObserver();
        attachRechargeWidgetObserver();
        attachPriceObserver();
        updateUpsellCardUrls();
        preselectRechargeFromQuery();
        // Prefer direct binding to plan buttons for deterministic navigation
        bindDirectPlanClicks();
        ensureRechargePlanMatchesInterval();
        updateBenefitsList(); // we need this for the subscribe benefits
        setStrikeThroughPriceFromV12();
        addPlanDiscountLabels();
    }, 150);
}

// Fast-path style re-injection to avoid a visible flicker on Recharge re-renders.
// We keep scheduleApply() debounced for heavier work, but styles can be applied immediately.
let __rc_stylesSoonPending = false;
function scheduleApplyStylesSoon() {
  if (__rc_stylesSoonPending) return;
  __rc_stylesSoonPending = true;

  Promise.resolve().then(() => {
    __rc_stylesSoonPending = false;
    if (!getRechargeWidget()) return;
    applyStyles();
  });
}

// Re-apply styles when Recharge re-renders its shadow DOM (e.g., switching subscription <-> onetime).
let __rc_widgetObserver;
let __rc_observedWidget;
function attachRechargeWidgetObserver() {
  const widget = getRechargeWidget();
  const root = widget?.shadowRoot;
  if (!widget || !root) return;

  if (__rc_widgetObserver && __rc_observedWidget === widget) return;

  if (__rc_widgetObserver) {
    try { __rc_widgetObserver.disconnect(); } catch (_) {}
    __rc_widgetObserver = undefined;
  }

  __rc_observedWidget = widget;

  __rc_widgetObserver = new MutationObserver(() => {
    // Any re-render inside the widget can recreate nested shadow roots -> styles need reinjection.
    scheduleApplyStylesSoon();
    scheduleApply();
  });

  __rc_widgetObserver.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['rc-selected', 'checked']
  });
}


/**
 * Takes the price from the selected Recharge plan and displays it in the Add to cart button.
 */
let __rc_updatingButtonLabel = false;
let __rc_addToCartLabelObserver;
function attachAddToCartLabelObserver() {
  const btnSpan = document.querySelector('.product-form__submit span');
  if (!btnSpan) return;

  // Already attached to the same node
  if (__rc_addToCartLabelObserver && btnSpan.__rcObserved === '1') return;

  // Disconnect any prior observer
  if (__rc_addToCartLabelObserver) {
    try { __rc_addToCartLabelObserver.disconnect(); } catch (_) {}
    __rc_addToCartLabelObserver = undefined;
  }

  btnSpan.__rcObserved = '1';

  __rc_addToCartLabelObserver = new MutationObserver(() => {
    // Ignore mutations caused by our own write
    if (__rc_updatingButtonLabel) return;

    // Theme scripts often re-write the label after variant changes; re-apply shortly after.
    setTimeout(syncAddToCartPrice, 0);
    setTimeout(syncAddToCartPrice, 250);
  });

  __rc_addToCartLabelObserver.observe(btnSpan, { childList: true, characterData: true, subtree: true });
}

function syncAddToCartPrice() {
  const widget = getRechargeWidget();
  if (!widget || !widget.shadowRoot) return;

  // Selected plan container
  const selected = widget.shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
  if (!selected) return;

  // rc-price without strike-through class
  let priceSpan = selected.querySelector('span.rc-price:not(.strike-through)');
  if (!priceSpan) {
    // fallback to first rc-price
    priceSpan = selected.querySelector('span.rc-price');
  }
  if (!priceSpan) return;

  const btnSpan = document.querySelector('.product-form__submit span');
  if (!btnSpan) return;

  // Base text (Add to cart) cached once
  const base = btnSpan.dataset.baseLabel || btnSpan.textContent.split(' – ')[0];
  btnSpan.dataset.baseLabel = base;

  // Extract Recharge price text
  const clone = priceSpan.cloneNode(true);
  clone.querySelectorAll('.visually-hidden').forEach(el => el.remove());
  const planText = clone.textContent.trim();

  // US-only: simple USD parsing/formatting
  const toCents = (txt) => Math.round(parseFloat((txt || '').replace(/[^0-9.]/g, '')) * 100) || 0;
  const formatUSD = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);

  const planCents = toCents(planText);
  let faucetCents = 0;
  const faucetPriceEl = document.querySelector('.faucet .faucet-card--selected .faucet-card__price');
  if (faucetPriceEl) faucetCents = toCents(faucetPriceEl.textContent.trim());

  const totalText = formatUSD(planCents + faucetCents);
  __rc_updatingButtonLabel = true;
  btnSpan.textContent = `${base} – ${totalText}`;
  // Keep the guard true until after MutationObserver callbacks have flushed
  setTimeout(() => { __rc_updatingButtonLabel = false; }, 0);
}

// --- Price observer setup ---
let priceObserver;
let priceRootObserver;
let priceObservedWidget;
let priceObservedNode;
function attachPriceObserver() {
  const widget = getRechargeWidget();
  if (!widget || !widget.shadowRoot) return;

  const priceTarget = widget.shadowRoot.querySelector('.rc-purchase-option[rc-selected] span.rc-price');
  if (!priceTarget) return; // Will try again later via scheduleApply

  // Already attached to the same widget/node, skip to avoid observer leaks and repeated work
  if (priceObserver && priceRootObserver && priceObservedWidget === widget && priceObservedNode === priceTarget) {
    return;
  }

  // Clear previous observers
  if (priceObserver) {
    try { priceObserver.disconnect(); } catch (_) {}
    priceObserver = undefined;
  }
  if (priceRootObserver) {
    try { priceRootObserver.disconnect(); } catch (_) {}
    priceRootObserver = undefined;
  }

  // Observe price text changes
  priceObserver = new MutationObserver(syncAddToCartPrice);
  priceObserver.observe(priceTarget, { characterData: true, childList: true, subtree: true });
  // Sync immediately
  syncAddToCartPrice();

  // Observe the whole shadow root for re-renders and reattach
  priceRootObserver = new MutationObserver(() => {
    // If the observed node got detached or rc-selected moved, reattach
    const current = widget.shadowRoot?.querySelector('.rc-purchase-option[rc-selected] span.rc-price');
    if (!current || current !== priceTarget) {
      attachPriceObserver();
    }
  });
  priceRootObserver.observe(widget.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['rc-selected'] });

  priceObservedWidget = widget;
  priceObservedNode = priceTarget;

  // First successful attach: stop startup retries to save cycles
  if (retryTimer) {
    clearInterval(retryTimer);
    retryTimer = null;
  }
}

// --- Startup / page guards ---
const __rc_isProductContext =
  !!document.querySelector('.product__info-container') ||
  document.body?.classList?.contains('template-product') ||
  document.querySelector('product-info');

// Only define retryTimer here; it will be started lazily for product pages
let retryTimer = null;

// Product page boot: react to the *real* triggers (widget ready, widget change, variant change).
if (__rc_isProductContext) {
  // Initial run (cheap guards inside scheduleApply)
  scheduleApply();

  // React to Recharge widget changes (selling plan / option toggles)
  document.addEventListener('change', (e) => {
    // Fast path: only react if the event is coming from the Recharge widget
    const widget = getRechargeWidget();
    if (!widget) return;
    const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
    if (path.includes(widget)) {
      requestAnimationFrame(scheduleApply);
    }
  }, true);

  // React to variant interval picker changes
  document.addEventListener('change', (e) => {
    if (!e.target || !e.target.matches) return;
    // interval radios live under <variant-selects>
    if (e.target.matches('variant-selects input[type="radio"][name^="intervals-"], variant-selects input[type="radio"][value="6"], variant-selects input[type="radio"][value="12"]')) {
      requestAnimationFrame(() => {
        // Keep Recharge selection in sync with interval, then refresh computed UI bits
        ensureRechargePlanMatchesInterval();
        scheduleApply();
        // Extra safety: theme may rewrite the button label after our first sync
        setTimeout(syncAddToCartPrice, 300);
      });
    }
  }, true);

  // Fallback: limited, low-frequency retries for late-rendered widget/shadow roots
  // (Stops automatically after first successful attachPriceObserver() call)
  let retries = 24; // ~6s total @ 250ms
  retryTimer = setInterval(() => {
    scheduleApply();
    if (--retries <= 0 && retryTimer) {
      clearInterval(retryTimer);
      retryTimer = null;
    }
  }, 250);

  let __rc_badgeResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(__rc_badgeResizeTimer);
    __rc_badgeResizeTimer = setTimeout(() => {
      applyDiscountBadgeAndStrikeThrough();
    }, 150);
  });
}

// --- Upsell cards <-> Recharge selection sync ---
function getSelectedPurchaseOption() {
    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    if (!root) return null;

    if (root.querySelector('.rc-purchase-option__subscription[rc-selected]')) return 'subscription';
    if (root.querySelector('.rc-selection__onetime[rc-selected]')) return 'onetime';
    return null;
}

function updateUpsellCardUrls() {
    const option = getSelectedPurchaseOption();
    if (!option) return;

    const cards = document.querySelectorAll('.upsell-card');
    if (!cards.length) return;

    for (const card of cards) {
        const initial = card.dataset.baseUrl || card.getAttribute('data-url');
        if (!card.dataset.baseUrl && initial) {
            card.dataset.baseUrl = initial;
        }
        const base = card.dataset.baseUrl || initial;
        if (!base) continue;

        let url;
        try {
            url = new URL(base, window.location.origin);
        } catch (e) {
            continue;
        }
        // Ensure only one param is present and preserve existing params
        url.searchParams.set('rc_po', option);
        const finalHref = url.pathname + url.search + url.hash;

        card.setAttribute('data-url', finalHref);

        const heading = card.querySelector('.upsell-card__heading');
        if (heading) heading.setAttribute('href', finalHref);
    }
}

// Inject hardcoded discount texts into plan buttons (6m/12m)
function addPlanDiscountLabels() {
    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    if (!root) return;

    // Helper: gather nodes inside nested shadow roots
    const collectDeep = (selector) => {
        const results = [...root.querySelectorAll(selector)];
        const hostSelectors = [
            'rc-selling-plans',
            'rc-plans',
            'rc-selling-plans-container',
            'rc-plans-container'
        ];
        hostSelectors.forEach((hs) => {
            root.querySelectorAll(hs).forEach((host) => {
                const sr = host && host.shadowRoot;
                if (!sr) return;
                results.push(...sr.querySelectorAll(selector));
            });
        });
        return results;
    };

    const buttons = collectDeep('.rc-plans-button-group .rc-plans-button');
    if (!buttons.length) return;

    buttons.forEach((btn, idx) => {
        const desired =
            idx === 0 ? 'Save 20% off refills' :
            idx === 1 ? 'Save 15% off refills' :
            null;

        let span = btn.querySelector('.rc-plans-button__discount');

        if (desired) {
            if (!span) {
                span = document.createElement('span');
                span.className = 'rc-plans-button__discount';
                span.setAttribute('part', 'rc-plans-button__discount');
                btn.appendChild(span);
            }
            if (span.textContent.trim() !== desired) {
                span.textContent = desired;
            }
        } else if (span) {
            // Remove for unexpected extra plans to avoid incorrect labels
            span.remove();
        }
    });
}

// --- Preselect Recharge widget from URL param ---
let preselectAttempted = false;
function preselectRechargeFromQuery() {
    if (preselectAttempted) return;

    const params = new URLSearchParams(window.location.search);
    const desired = params.get('rc_po');
    if (!desired) {
        preselectAttempted = true;
        return;
    }

    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    if (!root) return; // wait for next retry

    const target = desired === 'subscription'
        ? root.querySelector('.rc-purchase-option__subscription')
        : desired === 'onetime'
            ? root.querySelector('.rc-selection__onetime')
            : null;
    if (!target) return;

    if (target.hasAttribute('rc-selected')) {
        preselectAttempted = true;
        return;
    }

    const clickable = target.querySelector('label, button, input[type="radio"], .rc-purchase-option__label') || target;
    clickable.dispatchEvent(new MouseEvent('click', { bubbles: true, composed: true }));

    setTimeout(() => {
        if (target.hasAttribute('rc-selected')) {
            preselectAttempted = true;
            scheduleApply();
        }
    }, 120);
}

// React to faucet option changes and update button price
document.addEventListener('change', function(e){
    if (e.target && e.target.matches('.faucet input[name="faucet_variant_id"]')) {
        // Delay to allow DOM state toggles
        setTimeout(syncAddToCartPrice, 0);
    }
});

// --- Recharge plan <-> Variant "intervals" syncing (no dependency on visible dropdown) ---
function getVariantMetaFromTitle() {
    const el = document.querySelector('.product__title[data-v12-id]');
    if (!el) return null;
    const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };
    return {
        id6: el.getAttribute('data-v6-id') || null,
        id12: el.getAttribute('data-v12-id') || null,
        price6: toNum(el.getAttribute('data-v6-price')),
        price12: toNum(el.getAttribute('data-v12-price'))
    };
}

function getVariantIdFromUrl() {
    try {
        const url = new URL(window.location.href);
        return url.searchParams.get('variant');
    } catch (e) {
        return null;
    }
}

function navigateToVariantId(variantId, planIndex) {
    if (!variantId) return;
    try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        const next = url.pathname + url.search + url.hash;
        window.location.assign(next);
    } catch (e) {
        window.location.href = `?variant=${variantId}`;
    }
}

function repositionPurchaseOptionBadge(subscription, badge) {
    if (!subscription || !badge) return;

    const prices = subscription.querySelector('.rc-purchase-option__prices');
    if (!prices) return;

    const isCompact = window.matchMedia('(max-width: 1450px)').matches;
    if (isCompact) {
        if (badge.parentElement !== prices) {
            prices.insertBefore(badge, prices.firstChild);
        }
        return;
    }

    if (badge.parentElement !== subscription) {
        subscription.insertBefore(badge, subscription.firstChild);
    }
}

// New: Apply Shopify discount (rc_discount) and render badge + strike-through + discounted price
function applyDiscountBadgeAndStrikeThrough() {
    const titleEl = document.querySelector('.product__title[data-v12-id], .product__title[data-v6-id], .product__title[data-product-price]');
    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    if (!titleEl || !root) return;

    const v6Id = titleEl.getAttribute('data-v6-id');
    const v12Id = titleEl.getAttribute('data-v12-id');
    const isUV = String(__filterUVRaw) === 'true';

    // Determine current variant id (if any)
    const currentVar = (function() {
        const viaUrl = getVariantIdFromUrl();
        if (viaUrl) return viaUrl;
        const input = document.querySelector('product-info [id^="product-form-"] input[name="id"]');
        return input ? input.value : null;
    })();

    // Read base price in cents
    const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };
    let baseCents = 0;
    if (isUV) {
        baseCents = toNum(titleEl.getAttribute('data-product-price'));
    } else if (currentVar && v6Id && String(currentVar) === String(v6Id)) {
        baseCents = toNum(titleEl.getAttribute('data-v6-price'));
    } else if (currentVar && v12Id && String(currentVar) === String(v12Id)) {
        baseCents = toNum(titleEl.getAttribute('data-v12-price'));
    } else {
        // Fallback to product price if variant cannot be determined yet
        baseCents = toNum(titleEl.getAttribute('data-product-price'));
    }

    // Resolve discount percent (prefer per-variant rc_discount_variant, else product-level rc_discount)
    const parsePct = (raw) => {
        if (!raw) return 0;
        const m = String(raw).match(/-?\d+(\.\d+)?/);
        return m ? Math.max(0, parseFloat(m[0])) : 0;
    };
    let pct = 0;
    const v6PctRaw = titleEl.getAttribute('data-v6-rc_discount');
    const v12PctRaw = titleEl.getAttribute('data-v12-rc_discount');
    if (currentVar && v6Id && String(currentVar) === String(v6Id) && v6PctRaw) {
        pct = parsePct(v6PctRaw);
    } else if (currentVar && v12Id && String(currentVar) === String(v12Id) && v12PctRaw) {
        pct = parsePct(v12PctRaw);
    } else {
        pct = parsePct(titleEl.getAttribute('data-rc_discount'));
    }

    const formatUSD = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
    const discounted = (pct > 0 && baseCents > 0) ? Math.max(0, Math.round(baseCents * (1 - pct / 100))) : baseCents;

    // Locate subscription purchase option
    const subscription = root.querySelector('.rc-purchase-option__subscription');
    if (!subscription) return;

    // Ensure badge exists/updated
    let badge = subscription.querySelector('.rc-purchase-option__badge');
    if (pct > 0) {
        if (!badge) {
            badge = document.createElement('span');
            badge.className = 'rc-purchase-option__badge';
            badge.setAttribute('aria-hidden', 'true');
            badge.setAttribute('part', 'rc-purchase-option__badge');
            subscription.insertBefore(badge, subscription.firstChild);
        }
        const pctText = String(Math.round(pct)) + '% off';
        if (badge.textContent.trim() !== pctText) badge.textContent = pctText;
    } else if (badge) {
        badge.remove();
        badge = null;
    }

    // Ensure strike-through + discounted price are present/updated
    const prices = subscription.querySelector('.rc-purchase-option__prices');
    if (!prices) return;

    // Find or create strike-through element
    let strike = prices.querySelector('.rc-price.strike-through');
    if (pct > 0) {
        if (!strike) {
            // Optional screen-reader label
            const sr = document.createElement('span');
            sr.className = 'visually-hidden';
            sr.textContent = 'Original price strikethrough: ';
            prices.insertBefore(sr, prices.firstChild);

            strike = document.createElement('span');
            strike.className = 'rc-price strike-through text-muted';
            strike.setAttribute('part', 'rc-purchase-option__original-price');
            prices.insertBefore(strike, prices.firstChild.nextSibling);
        }
        const strikeText = formatUSD(baseCents);
        if (strike.textContent.trim() !== strikeText) strike.textContent = strikeText;
    } else if (strike) {
        // Remove strike-through if no discount
        // remove preceding visually-hidden label if present
        const prev = strike.previousElementSibling;
        if (prev && prev.classList.contains('visually-hidden')) prev.remove();
        strike.remove();
        strike = null;
    }

    // Update discounted price element
    let discountedEl =
        prices.querySelector('span.rc-price[part~="rc-purchase-option__discounted-price"]') ||
        prices.querySelector('span.rc-price:not(.strike-through)');
    if (!discountedEl) {
        discountedEl = document.createElement('span');
        discountedEl.className = 'rc-price';
        discountedEl.setAttribute('part', 'rc-purchase-option__discounted-price');
        prices.appendChild(discountedEl);
    }
    const discText = formatUSD(discounted);
    if (discountedEl.textContent.trim() !== discText) discountedEl.textContent = discText;

    if (badge) {
        repositionPurchaseOptionBadge(subscription, badge);
    }
}

// Back-compat: keep the name used elsewhere, but now delegate to the new function
function setStrikeThroughPriceFromV12() {
    applyDiscountBadgeAndStrikeThrough();
}

// Direct, minimal binding to plan buttons (labels)
function bindDirectPlanClicks() {
    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    if (!root) return;

    // Ensure hidden selling_plan input exists and set its value
    const ensureFormSellingPlan = (planId) => {
        try {
            if (!planId) return;
            const form = document.querySelector('product-form form') || document.querySelector('product-info [id^="product-form-"] form');
            if (!form) return;
            let sp = form.querySelector('input[name="selling_plan"]');
            if (!sp) {
                sp = document.createElement('input');
                sp.type = 'hidden';
                sp.name = 'selling_plan';
                form.appendChild(sp);
            }
            if (sp.value !== String(planId)) sp.value = String(planId);
        } catch (_) {}
    };

    // Helper: gather nodes from root and known nested shadow hosts (Recharge composes multiple shadow roots)
    const collectDeep = (selector) => {
        const results = [...root.querySelectorAll(selector)];
        const hostSelectors = [
            'rc-selling-plans',
            'rc-plans',
            'rc-selling-plans-container',
            'rc-plans-container'
        ];
        hostSelectors.forEach((hs) => {
            root.querySelectorAll(hs).forEach((host) => {
                const sr = host && host.shadowRoot;
                if (!sr) return;
                results.push(...sr.querySelectorAll(selector));
            });
        });
        return results;
    };

    // Select variant radio in visible variant picker (no page reload)
    const selectVariantByIndex = (idx) => {
        try {
            const desiredVal = idx === 0 ? '6' : '12';
            const vs = document.querySelector('variant-selects');
            if (!vs) return;
            // If already selected, skip redundant click
            const already = vs.querySelector('input[type="radio"][name^="intervals-"]:checked') || vs.querySelector('input[type="radio"][value="6"]:checked, input[type="radio"][value="12"]:checked');
            if (already && (already.value || '').trim() === desiredVal) return;
            // Prefer exact value match under variant-selects
            let radio = vs.querySelector(`input[type="radio"][value="${desiredVal}"]`);
            if (!radio) {
                // fallback: any radio whose value equals desired
                radio = document.querySelector(`variant-selects input[type="radio"][value="${desiredVal}"]`);
            }
            if (radio) {
                // Click associated label to trigger native behavior and theme's handlers
                const lbl = document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
                if (lbl) {
                    // defer to exit Recharge shadow event stack
                    setTimeout(() => lbl.click(), 0);
                } else {
                    setTimeout(() => radio.click(), 0);
                }
            }
        } catch (_) {}
    };

    // Ensure widget plan buttons visually reflect selection (data-checked and part)
    const setWidgetPlanVisual = (idx) => {
        try {
            const buttons = collectDeep('.rc-plans-button-group .rc-plans-button');
            const radios = collectDeep('.rc-plans-button-group input[type="radio"][name="rc_plan"]');
            if (!buttons.length) return;
            buttons.forEach((btn, i) => {
                if (i === idx) {
                    btn.setAttribute('data-checked', '');
                    const parts = (btn.getAttribute('part') || '').split(/\s+/).filter(Boolean);
                    if (!parts.includes('rc-plans-button')) parts.unshift('rc-plans-button');
                    if (!parts.includes('rc-plans-button__selected')) parts.push('rc-plans-button__selected');
                    btn.setAttribute('part', parts.join(' '));
                } else {
                    btn.removeAttribute('data-checked');
                    const parts = (btn.getAttribute('part') || '').split(/\s+/).filter(Boolean).filter(p => p !== 'rc-plans-button__selected');
                    if (parts.length) btn.setAttribute('part', parts.join(' '));
                }
            });
            // reflect radio checked state inside widget for completeness
            radios.forEach((r, i) => {
                const should = i === idx;
                if (r.checked !== should) r.checked = should;
                if (should) r.setAttribute('checked', ''); else r.removeAttribute('checked');
            });
        } catch (_) {}
    };

    const labels = collectDeep('.rc-plans-button-group label');
    const radios = collectDeep('.rc-plans-button-group input[type="radio"][name="rc_plan"]');
    if (!labels.length && !radios.length) return;

    const navByIndex = (idx) => {
        // Only switch variant locally (no URL navigation)
        selectVariantByIndex(idx);
        setWidgetPlanVisual(idx);
        // Set selling_plan hidden input from widget radios
        try {
            const radiosNow = collectDeep('.rc-plans-button-group input[type="radio"][name="rc_plan"]');
            const r = radiosNow[idx];
            const planId = r?.value;
            if (planId) ensureFormSellingPlan(planId);
        } catch (_) {}
    };

    labels.forEach((label, idx) => {
        if (label.dataset.rcDirectBound === '1') return;
        label.dataset.rcDirectBound = '1';
        label.addEventListener('click', (e) => {
            try { e.preventDefault(); } catch(_) {}
            try { e.stopImmediatePropagation?.(); } catch(_) {}
            try { e.stopPropagation?.(); } catch(_) {}
            setTimeout(() => navByIndex(idx), 0);
        }, { capture: true });
    });

    radios.forEach((input, idx) => {
        if (input.dataset.rcDirectBound === '1') return;
        input.dataset.rcDirectBound = '1';
        // route radio clicks to variant-selects only
        input.addEventListener('click', (e) => {
            try { e.preventDefault(); } catch(_) {}
            try { e.stopImmediatePropagation?.(); } catch(_) {}
            try { e.stopPropagation?.(); } catch(_) {}
            setTimeout(() => navByIndex(idx), 0);
        }, { capture: true });
    });

    // Extra safety: capture at root to preempt Recharge handlers that might be re-bound on rerender
    if (!root.__rcPlansCaptureBound) {
        root.__rcPlansCaptureBound = true;
        const handler = (e) => {
            const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
            let idx = -1;
            for (const node of path) {
                if (!node) continue;
                if (node.tagName === 'LABEL') {
                    const j = labels.indexOf(node);
                    if (j !== -1) { idx = j; break; }
                }
                if (node.matches && node.matches('input[type="radio"][name="rc_plan"]')) {
                    const lbl = node.closest('label');
                    const j = lbl ? labels.indexOf(lbl) : -1;
                    if (j !== -1) { idx = j; break; }
                }
            }
            if (idx === -1) return;
            try { e.preventDefault(); } catch(_) {}
            try { e.stopImmediatePropagation?.(); } catch(_) {}
            try { e.stopPropagation?.(); } catch(_) {}
            setTimeout(() => navByIndex(idx), 0);
        };
        root.addEventListener('click', handler, true);
        root.addEventListener('change', handler, true);
    }
}

// Prevent overlapping long retry loops inside ensureRechargePlanMatchesInterval()
let __rc_ensurePlanInFlight = false;

function ensureRechargePlanMatchesInterval() {
    if (__rc_ensurePlanInFlight) return;
    __rc_ensurePlanInFlight = true;

    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    if (!root) {
        __rc_ensurePlanInFlight = false;
        return;
    }

    // Determine desired plan index from currently selected variant in variant picker
    const vs = document.querySelector('variant-selects');
    const selectedRadio = vs?.querySelector('input[type="radio"][name^="intervals-"]:checked') || vs?.querySelector('input[type="radio"][value="6"]:checked, input[type="radio"][value="12"]:checked');
    const desiredIdx = selectedRadio?.value?.trim() === '12' ? 1 : 0;

    // Helper to collect elements from nested shadow roots as well
    const collectDeep = (selector) => {
        const results = [...root.querySelectorAll(selector)];
        const hostSelectors = [
            'rc-selling-plans',
            'rc-plans',
            'rc-selling-plans-container',
            'rc-plans-container'
        ];
        hostSelectors.forEach((hs) => {
            root.querySelectorAll(hs).forEach((host) => {
                const sr = host && host.shadowRoot;
                if (!sr) return;
                results.push(...sr.querySelectorAll(selector));
            });
        });
        return results;
    };

    const applySelection = (attempt = 0) => {
        const labelsDeep = collectDeep('.rc-plans-button-group label');
        const buttonsDeep = collectDeep('.rc-plans-button-group .rc-plans-button');
        const radiosDeep = collectDeep('.rc-plans-button-group input[type="radio"][name="rc_plan"]');
        if ((labelsDeep.length < 2) && attempt < 100) {
            setTimeout(() => applySelection(attempt + 1), 50);
            return;
        }
        if ((labelsDeep.length < 2) && attempt >= 100) {
            __rc_ensurePlanInFlight = false;
            return;
        }
        if (labelsDeep.length >= 2) {
            // Guard: if widget already has desired selection, skip
            let currentIdx = -1;
            if (buttonsDeep.length >= 2) {
                const checkedBtn = buttonsDeep.findIndex((b) => b.hasAttribute('data-checked'));
                if (checkedBtn !== -1) currentIdx = checkedBtn;
            }
            if (currentIdx === -1 && radiosDeep.length >= 2) {
                const checkedRadio = radiosDeep.findIndex((r) => r.checked);
                if (checkedRadio !== -1) currentIdx = checkedRadio;
            }
            if (currentIdx === desiredIdx) {
                setTimeout(setStrikeThroughPriceFromV12, 120);
                // Ensure selling_plan input is set even if widget already selected
                try {
                    const r = radiosDeep[desiredIdx];
                    const planId = r?.value;
                    if (planId) {
                        const form = document.querySelector('product-form form') || document.querySelector('product-info [id^="product-form-"] form');
                        if (form) {
                            let sp = form.querySelector('input[name="selling_plan"]');
                            if (!sp) {
                                sp = document.createElement('input');
                                sp.type = 'hidden';
                                sp.name = 'selling_plan';
                                form.appendChild(sp);
                            }
                            if (sp.value !== String(planId)) sp.value = String(planId);
                        }
                    }
                } catch (_) {}
                __rc_ensurePlanInFlight = false;
                return;
            }
            // Simulate a real click on the desired label to let Recharge update prices
            const targetLabel = labelsDeep[desiredIdx];
            const clickable = targetLabel?.querySelector('input[type="radio"], button, .rc-plans-button') || targetLabel;
            if (clickable) {
                clickable.dispatchEvent(new MouseEvent('click', { bubbles: true, composed: true }));
            }
            // Sync strike-through after Recharge applies changes
            setTimeout(setStrikeThroughPriceFromV12, 120);
            // Also set selling_plan hidden input based on radios
            try {
                const r = radiosDeep[desiredIdx];
                const planId = r?.value;
                if (planId) {
                    const form = document.querySelector('product-form form') || document.querySelector('product-info [id^="product-form-"] form');
                    if (form) {
                        let sp = form.querySelector('input[name="selling_plan"]');
                        if (!sp) {
                            sp = document.createElement('input');
                            sp.type = 'hidden';
                            sp.name = 'selling_plan';
                            form.appendChild(sp);
                        }
                        if (sp.value !== String(planId)) sp.value = String(planId);
                    }
                }
            } catch (_) {}
            __rc_ensurePlanInFlight = false;
        }
    };

    applySelection(0);

    // Always keep strike-through synced to the 12-month base price
    setStrikeThroughPriceFromV12();
}

// Attach submit guard to ensure selling_plan is set just before submission
(function attachFormSubmitGuard() {
    try {
        const form = document.querySelector('product-form form') || document.querySelector('product-info [id^="product-form-"] form');
        if (!form || form.__rcPlanSubmitBound) return;
        form.__rcPlanSubmitBound = true;
        form.addEventListener('submit', (e) => {
            try {
                const widget = getRechargeWidget();
                const root = widget?.shadowRoot;
                if (!root) return;
                const vs = document.querySelector('variant-selects');
                const selectedRadio = vs?.querySelector('input[type="radio"][name^="intervals-"]:checked') || vs?.querySelector('input[type="radio"][value="6"]:checked, input[type="radio"][value="12"]:checked');
                const wantIdx = selectedRadio?.value?.trim() === '12' ? 1 : 0;
                const radiosDeep = (() => {
                    const results = [...(root.querySelectorAll('.rc-plans-button-group input[type="radio"][name="rc_plan"]') || [])];
                    const hosts = ['rc-selling-plans','rc-plans','rc-selling-plans-container','rc-plans-container'];
                    hosts.forEach((hs) => {
                        root.querySelectorAll(hs).forEach((host) => {
                            const sr = host && host.shadowRoot;
                            if (!sr) return;
                            results.push(...sr.querySelectorAll('.rc-plans-button-group input[type="radio"][name="rc_plan"]'));
                        });
                    });
                    return results;
                })();
                let planId = null;
                if (radiosDeep.length >= 2 && radiosDeep[wantIdx]) {
                    planId = radiosDeep[wantIdx].value || null;
                } else {
                    // As a last resort, pick by aria-label contains "6 months"/"12 months"
                    const byText = Array.from(radiosDeep).find((r) => {
                        const lbl = (r.getAttribute('aria-label') || '').toLowerCase();
                        return wantIdx === 0 ? lbl.includes('6 months') : lbl.includes('12 months');
                    });
                    planId = byText?.value || null;
                }
                if (planId) {
                    let sp = form.querySelector('input[name="selling_plan"]');
                    if (!sp) {
                        sp = document.createElement('input');
                        sp.type = 'hidden';
                        sp.name = 'selling_plan';
                        form.appendChild(sp);
                    }
                    sp.value = String(planId);
                }
            } catch (_) {}
        }, true); // capture to run before product-form handler
    } catch (_) {}
})();

// --- Update benefits list content from variant metafields (recharge_list) ---
function updateBenefitsList() {
    const widget = getRechargeWidget();
    const root = widget?.shadowRoot;
    const titleEl = document.querySelector('.product__title[data-v12-id]');
    if (!root || !titleEl) return;

    const v6Id = titleEl.getAttribute('data-v6-id');
    const v12Id = titleEl.getAttribute('data-v12-id');

    let itemsRaw = '';
    // IMPORTANT: choose benefits by selected "intervals" first.
    // Variant id updates can lag behind the intervals radio click, which causes a one-step offset (6 shows 12 and vice-versa).
    const selectedInterval = (() => {
        try {
            const vs = document.querySelector('variant-selects');
            const r =
                vs?.querySelector('input[type="radio"][name^="intervals-"]:checked') ||
                vs?.querySelector('input[type="radio"][value="6"]:checked, input[type="radio"][value="12"]:checked');
            const v = (r?.value || '').trim();
            if (v === '6' || v === '12') return v;
        } catch (_) {}
        return null;
    })();

    if (selectedInterval === '6') {
        itemsRaw = (titleEl.getAttribute('data-v6-benefits') || '').trim();
    } else if (selectedInterval === '12') {
        itemsRaw = (titleEl.getAttribute('data-v12-benefits') || '').trim();
    } else {
        // Fallback: decide by variant id (legacy behavior)
        const currentVar = (function() {
            const idFromUrl = getVariantIdFromUrl();
            if (idFromUrl) return idFromUrl;
            const input = document.querySelector('product-info [id^="product-form-"] input[name="id"]');
            return input ? input.value : null;
        })();

        if (currentVar && v6Id && String(currentVar) === String(v6Id)) {
            itemsRaw = (titleEl.getAttribute('data-v6-benefits') || '').trim();
        } else if (currentVar && v12Id && String(currentVar) === String(v12Id)) {
            itemsRaw = (titleEl.getAttribute('data-v12-benefits') || '').trim();
        } else {
            // If no explicit variant/interval, skip (let Recharge default)
            return;
        }
    }

    if (!itemsRaw) return;
    const items = itemsRaw.split('||').map(s => s.trim()).filter(Boolean);
    if (!items.length) return;

    // Helper to gather from nested shadow roots
    const collectDeep = (selector) => {
        const results = [...root.querySelectorAll(selector)];
        const hostSelectors = ['rc-benefits'];
        hostSelectors.forEach((hs) => {
            root.querySelectorAll(hs).forEach((host) => {
                const sr = host && host.shadowRoot;
                if (!sr) return;
                results.push(...sr.querySelectorAll(selector));
            });
        });
        return results;
    };

    const lists = collectDeep('.rc-benefits__list ul');
    if (!lists.length) return;

    // Allow only <s> via [s]...[/s] placeholders; escape everything else
    const normalize = (txt) => {
        let out = String(txt || '');
        // escape all HTML entities first
        out = out.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        // convert placeholders to real <s> tags
        out = out.replace(/\[s\]/gi, '<s>').replace(/\[\/s\]/gi, '</s>');
        return out;
    };

    const newHTML = items.map((t) => `<li><p>${normalize(t)}</p></li>`).join('');

    lists.forEach((ul) => {
        const currentHash = ul.getAttribute('data-custom-benefits-hash');
        const nextHash = String(items.join('|'));
        if (currentHash === nextHash) return;
        ul.innerHTML = newHTML;
        ul.setAttribute('data-custom-benefits-hash', nextHash);
    });
}

// Best-effort correction: ensure discounted price matches selected plan percentage
// (Removed manual discounted price correction - we rely on simulated click to update UI)


// Add class to recharge widget for PDP redesign

document.addEventListener('DOMContentLoaded', () => {
    const TARGET_PRODUCT_IDS = [
      '12018270142782',
      '12018271650110',
      '12018271486270',
      '12018270241086',
      '12011760976190',
      '12011773362494',
      '12006228951358',
      '12690132730174',
    ];
  
    const applyClass = () => {
      const selector = TARGET_PRODUCT_IDS
        .map((id) => `recharge-subscription-widget[product-id="${id}"]`)
        .join(',');
      const widgets = document.querySelectorAll(selector);
      if (!widgets.length) return false;

      let applied = false;

      widgets.forEach((widget) => {
        if (!widget?.shadowRoot) return;

        // Widget root
        const root = widget.shadowRoot.querySelector('.rc-widget__root');
        if (root) {
          root.classList.add('rc-widget-redesign');
          applied = true;
        }

        // Benefits list
        widget.shadowRoot.querySelectorAll('rc-benefits').forEach((benefits) => {
          if (!benefits.shadowRoot) return;

          benefits.shadowRoot
            .querySelector('.rc-benefits__list')
            ?.classList.add('rc-widget-redesign');
        });

        // selling list
        widget.shadowRoot.querySelectorAll('rc-selling-plans').forEach((selling) => {
          if (!selling.shadowRoot) return;

          selling.shadowRoot
            .querySelector('.rc-plans-button-group')
            ?.classList.add('rc-widget-redesign');

          selling.shadowRoot
            .querySelector('.rc-plans-dropdown')
            ?.classList.add('rc-widget-redesign');
        });

        // selling list
        widget.shadowRoot.querySelectorAll('rc-onetime-drawbacks').forEach((drawbacks) => {
          if (!drawbacks.shadowRoot) return;

          drawbacks.shadowRoot
            .querySelector('.rc-benefits__list')
            ?.classList.add('rc-widget-redesign');
        });
      });

      return applied;
    };

    
    const interval = setInterval(() => {
      if (applyClass()) {
        clearInterval(interval);
      }
    }, 300);
  
    setTimeout(() => clearInterval(interval), 10000);
  
    const pageObserver = new MutationObserver(() => {
      applyClass();
    });
  
    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });